import { KOALA, GYPSUM } from 'visitor-ui-component-library/constants/WidgetColors';
const defaultFileAttachmentTheme = {
  tileBackgroundColor: GYPSUM,
  tileBorderColor: KOALA
};
const FileAttachmentTheme = themeProps => Object.assign({}, defaultFileAttachmentTheme, themeProps);
export default FileAttachmentTheme;